// extracted by mini-css-extract-plugin
module.exports =  {"gray-item":"Item-a69g__gray-item","index":"Item-XsAv__index"};